import { initialFormData } from "@/utils/enum";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  summerCampEventsCount: 0,
  summerCampEvents: [],
  summerCampSearchData: { ...initialFormData },
};

const summerCampEventSlice = createSlice({
  name: "summerCampEvents",
  initialState,
  reducers: {
    setSummerCampEventsCount: (state, action) => {
      state.summerCampEventsCount = action.payload;
    },
    setSummerCampEvents: (state, action) => {
      state.summerCampEvents = action.payload;
    },
    setSearchData: (state, action) => {
      state.summerCampSearchData = action.payload;
    },
    clearSummerCampData: (state) => {
      state.summerCampEventsCount = 0;
      state.summerCampEvents = [];
      state.summerCampSearchData = { ...initialFormData };
    },
  },
});

export const {
  setSummerCampEventsCount,
  setSummerCampEvents,
  setSearchData,
  clearSummerCampData,
} = summerCampEventSlice.actions;

export default summerCampEventSlice.reducer;
